import {useEffect} from "react";
import {useLocation, useNavigate} from "react-router-dom";
import {PATHS} from "../../routes";
import Header from "@arelia-components/layout/Header";
import {ContentBox} from "@arelia-components/ui-atoms/ContentBox";
import {ConnectionName} from "@arelia-types/connection";
import Content from "@arelia-components/layout/Content";

export default function Streaming() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const navOptions = [
    { value: PATHS.STREAMING + "/plays", label: "Plays" },
    { value: PATHS.STREAMING + "/audience", label: "Audience" },
  ];

  useEffect(() => {
    if (pathname === PATHS.STREAMING) {
      navigate(PATHS.STREAMING + "/audience");
    }
  }, [pathname]);

  return (
    <ContentBox>
      <Header
        title="Streaming"
        navOptions={navOptions}
        navValue={pathname}
        setNavValue={navigate}
      />
      <Content requiredConnectionNames={[ConnectionName.youtube, ConnectionName.spotify, ConnectionName.amazon, ConnectionName.appleMusic, ConnectionName.pandora]} />
    </ContentBox>
  );
}
